import type { AllRoles } from "@daytrip/legacy-enums";
import { Expose } from "class-transformer";
import { IsDefined, IsArray, IsOptional } from "class-validator";

import { RoleDetails } from "../types/RoleDetails";

export class UserRoles {
    @IsArray()
    @IsDefined()
    @Expose()
    public roles: Array<AllRoles> = [];

    @IsOptional()
    @Expose()
    public roleDetails?: RoleDetails;
}
